/**
 * Jwear cookie consent
 * - Default: auto-grant analytics/marketing/preferences/sale_of_data (no banner)
 * - Optional banner via Theme settings → Jwear popups → jw_cookie_banner_enable
 * - setTrackingConsent + Clarity consentv2 + flush delayed third parties
 * - Accept clicks are debounced; banner hides even if Shopify network callback fails
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jw_cookie_consent_v1';
  var STYLE_ID = 'jw-cookie-banner-injected';
  var CONSENT_TIMEOUT_MS = 2500;
  var cfg = window.JW_COOKIE || {};
  var bannerEnabled = cfg.bannerEnable === true;

  /* -------------------------------------------------------------------------- */
  /* Consentmo visual polish (only when a third-party CMP is present)             */
  /* -------------------------------------------------------------------------- */

  var SHADOW_CSS = [
    '[aria-label="Cookie bar"],',
    '[data-csm-data-container],',
    '.isense-cc-window,',
    '.cc-window {',
    '  background: linear-gradient(180deg, #faf8f4 0%, #ffffff 42%) !important;',
    '  color: #69665f !important;',
    '  border: 1px solid #eae5d8 !important;',
    '  border-radius: 12px !important;',
    '  box-shadow: 0 12px 40px rgba(44, 33, 24, 0.14), 0 2px 8px rgba(44, 33, 24, 0.06) !important;',
    '  padding: 1.25rem 1.35rem 1.15rem !important;',
    '  font-family: inherit !important;',
    '}',
    '[aria-label="Cookie bar"] p,',
    '[data-csm-data-container] p,',
    '.cc-message,',
    '.isense-cc-window p {',
    '  color: #69665f !important;',
    '  font-size: 0.875rem !important;',
    '  line-height: 1.55 !important;',
    '}',
    '[aria-label="Cookie bar"] a,',
    '[data-csm-data-container] a,',
    '.isense-cc-window a {',
    '  color: #2c2118 !important;',
    '  text-decoration: underline !important;',
    '  text-underline-offset: 0.18em !important;',
    '  font-weight: 500 !important;',
    '}',
    '.cc-compliance,',
    '.isense-cc-compliance,',
    '[class*="buttongroup"] {',
    '  display: flex !important;',
    '  flex-wrap: wrap !important;',
    '  gap: 0.5rem !important;',
    '  align-items: stretch !important;',
    '}',
    'button, .cc-btn, [role="button"] {',
    '  font-family: inherit !important;',
    '  font-size: 0.8125rem !important;',
    '  font-weight: 600 !important;',
    '  letter-spacing: 0.04em !important;',
    '  border-radius: 6px !important;',
    '  min-height: 2.5rem !important;',
    '  padding: 0.65rem 1rem !important;',
    '  cursor: pointer !important;',
    '  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease !important;',
    '  box-sizing: border-box !important;',
    '}',
    '@media (max-width: 699px) {',
    '  .cc-compliance, .isense-cc-compliance, [class*="buttongroup"] {',
    '    width: 100% !important;',
    '  }',
    '  button, .cc-btn, [role="button"] {',
    '    min-height: 2.75rem !important;',
    '  }',
    '}'
  ].join('\n');

  function buttonKind(el) {
    var t = ((el.textContent || '') + ' ' + (el.getAttribute('aria-label') || '')).toLowerCase().trim();
    if (/accept|allow|agree|akzeptieren|accepter|aceptar|accetta/.test(t)) return 'accept';
    if (/reject|decline|deny|refuse|ablehnen|refuser|rechazar|rifiuta|necessary/.test(t)) return 'reject';
    if (/prefer|manage|setting|einstell|préfér|preferenc|gestisci|config/.test(t)) return 'prefs';
    return '';
  }

  function applyButtonHierarchy(root) {
    var nodes = root.querySelectorAll('button, .cc-btn, [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.id === 'csm-close-btn') continue;
      var kind = buttonKind(el);
      if (kind === 'accept') {
        el.style.setProperty('background', '#2c2118', 'important');
        el.style.setProperty('background-color', '#2c2118', 'important');
        el.style.setProperty('color', '#ffffff', 'important');
        el.style.setProperty('border', '1px solid #2c2118', 'important');
        el.style.setProperty('text-decoration', 'none', 'important');
        el.style.setProperty('box-shadow', '0 1px 2px rgba(44, 33, 24, 0.18)', 'important');
      } else if (kind === 'reject') {
        el.style.setProperty('background', '#ffffff', 'important');
        el.style.setProperty('background-color', '#ffffff', 'important');
        el.style.setProperty('color', '#2c2118', 'important');
        el.style.setProperty('border', '1px solid #2c2118', 'important');
        el.style.setProperty('text-decoration', 'none', 'important');
        el.style.setProperty('box-shadow', 'none', 'important');
      } else if (kind === 'prefs') {
        el.style.setProperty('background', 'transparent', 'important');
        el.style.setProperty('background-color', 'transparent', 'important');
        el.style.setProperty('color', '#69665f', 'important');
        el.style.setProperty('border', '1px solid transparent', 'important');
        el.style.setProperty('text-decoration', 'underline', 'important');
        el.style.setProperty('text-underline-offset', '0.2em', 'important');
        el.style.setProperty('font-weight', '500', 'important');
        el.style.setProperty('box-shadow', 'none', 'important');
      }
    }
  }

  function injectIntoShadow(host) {
    if (!host || !host.shadowRoot) return;
    var root = host.shadowRoot;
    if (!root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = SHADOW_CSS;
      root.appendChild(style);
    }
    applyButtonHierarchy(root);
  }

  function polishConsentmo() {
    var hosts = document.querySelectorAll('csm-cookie-consent, .csm-cmp-root');
    for (var i = 0; i < hosts.length; i++) injectIntoShadow(hosts[i]);
    return hosts.length > 0;
  }

  function startConsentmoPolish() {
    if (!bannerEnabled) return;
    var obs = null;
    var passes = 0;
    var maxPasses = 20;

    function stopObserver() {
      if (!obs) return;
      obs.disconnect();
      obs = null;
    }

    function polishAndStopWhenFound() {
      if (polishConsentmo()) stopObserver();
    }

    polishAndStopWhenFound();
    if (!document.querySelector('csm-cookie-consent, .csm-cmp-root')) {
      obs = new MutationObserver(polishAndStopWhenFound);
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }

    var timer = setInterval(function () {
      polishAndStopWhenFound();
      passes += 1;
      if (passes >= maxPasses) {
        clearInterval(timer);
        stopObserver();
      }
    }, 500);
  }

  /* -------------------------------------------------------------------------- */
  /* Consent helpers                                                              */
  /* -------------------------------------------------------------------------- */

  function hasThirdPartyBanner() {
    return !!(
      document.querySelector('#shopify-pc__banner, #shopify-pc__prefs') ||
      document.querySelector('csm-cookie-consent, .csm-cmp-root, .cc-window, .isense-cc-window')
    );
  }

  /** When banner is off, hide Shopify PC / Consentmo / legacy CMP UIs. */
  function suppressThirdPartyBanners() {
    if (bannerEnabled) return;
    try {
      document.documentElement.classList.add('jw-cookie-auto-grant');
    } catch (e) {}
    var nodes = document.querySelectorAll(
      '#shopify-pc__banner, #shopify-pc__prefs, #shopify-pc__banner__dialog,' +
        'csm-cookie-consent, .csm-cmp-root, .cc-window, .isense-cc-window,' +
        '[aria-label="Cookie bar"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      try {
        nodes[i].style.setProperty('display', 'none', 'important');
        nodes[i].setAttribute('hidden', '');
        nodes[i].setAttribute('aria-hidden', 'true');
      } catch (e2) {}
    }
  }

  function readStoredConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && (parsed.choice === 'accepted' || parsed.choice === 'declined')) return parsed;
    } catch (e) {}
    return null;
  }

  function writeStoredConsent(choice) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice: choice, ts: Date.now() })
      );
    } catch (e) {}
    try {
      var maxAge = 60 * 60 * 24 * 365;
      document.cookie =
        STORAGE_KEY +
        '=' +
        encodeURIComponent(choice) +
        '; path=/; max-age=' +
        maxAge +
        '; SameSite=Lax';
    } catch (e2) {}
  }

  function getBanner() {
    return document.querySelector('[data-jw-cookie-banner]');
  }

  function showBanner() {
    if (!bannerEnabled) return;
    var el = getBanner();
    if (!el) return;
    el.hidden = false;
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
  }

  function hideBanner() {
    var el = getBanner();
    if (!el) return;
    el.classList.remove('is-visible');
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
  }

  function signalClarityConsent(accepted) {
    try {
      if (typeof window.clarity !== 'function') return;
      var storage = accepted ? 'granted' : 'denied';
      if (accepted) {
        window.clarity('consent');
      }
      window.clarity('consentv2', {
        ad_Storage: storage,
        analytics_Storage: storage
      });
    } catch (e) {}
  }

  function flushTrackingParties() {
    try {
      if (typeof window.__jwFlushThirdParty === 'function') {
        window.__jwFlushThirdParty();
      }
    } catch (e) {}
  }

  /**
   * Persist + signal immediately, then call Shopify API.
   * Always invokes done (once) even if setTrackingConsent network/callback fails.
   */
  function setConsent(accepted, done) {
    var choice = accepted ? 'accepted' : 'declined';
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      signalClarityConsent(accepted);
      if (accepted) flushTrackingParties();
      if (typeof done === 'function') {
        try {
          done();
        } catch (e) {}
      }
    }

    writeStoredConsent(choice);
    signalClarityConsent(accepted);
    if (accepted) flushTrackingParties();

    var safety = setTimeout(finish, CONSENT_TIMEOUT_MS);

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      try {
        privacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted
          },
          function () {
            clearTimeout(safety);
            finish();
          }
        );
        return;
      } catch (e) {
        try {
          privacy.setTrackingConsent(accepted, function () {
            clearTimeout(safety);
            finish();
          });
          return;
        } catch (e2) {}
      }
    }

    clearTimeout(safety);
    finish();
  }

  function grantAllConsent(done) {
    setConsent(true, done);
  }

  function bindActions() {
    var el = getBanner();
    if (!el || el.getAttribute('data-jw-bound') === '1') return;
    el.setAttribute('data-jw-bound', '1');

    var acceptBtn = el.querySelector('[data-jw-cookie-accept]');
    var declineBtn = el.querySelector('[data-jw-cookie-decline]');
    var busy = false;

    function onChoice(accepted) {
      if (busy) return;
      busy = true;
      if (acceptBtn) acceptBtn.disabled = true;
      if (declineBtn) declineBtn.disabled = true;
      // Hide immediately so NetworkError / slow Shopify callbacks cannot leave UI stuck
      hideBanner();
      setConsent(accepted, function () {
        busy = false;
      });
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function (evt) {
        try {
          if (evt && typeof evt.preventDefault === 'function') evt.preventDefault();
        } catch (e) {}
        onChoice(true);
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function (evt) {
        try {
          if (evt && typeof evt.preventDefault === 'function') evt.preventDefault();
        } catch (e) {}
        onChoice(false);
      });
    }
  }

  function shouldShowWithApi() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;

    try {
      var gdpr =
        typeof privacy.shouldShowGDPRBanner === 'function' &&
        !!privacy.shouldShowGDPRBanner();
      var ccpa =
        typeof privacy.shouldShowCCPABanner === 'function' &&
        !!privacy.shouldShowCCPABanner();
      if (
        typeof privacy.shouldShowGDPRBanner === 'function' ||
        typeof privacy.shouldShowCCPABanner === 'function'
      ) {
        if (gdpr || ccpa) return true;
      }
    } catch (e) {}

    if (typeof privacy.shouldShowBanner === 'function') {
      try {
        return !!privacy.shouldShowBanner();
      } catch (e2) {
        return false;
      }
    }
    return null;
  }

  function marketingIsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return null;
    try {
      return !!privacy.marketingAllowed();
    } catch (e) {
      return null;
    }
  }

  function analyticsIsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return null;
    try {
      return !!privacy.analyticsProcessingAllowed();
    } catch (e) {
      return null;
    }
  }

  function trackingIsBlocked() {
    var m = marketingIsAllowed();
    var a = analyticsIsAllowed();
    if (m === null && a === null) return false;
    return m === false || a === false;
  }

  function visitorHasAccepted() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      if (typeof privacy.currentVisitorConsent === 'function') {
        var c = privacy.currentVisitorConsent();
        if (c && c.marketing === 'yes' && c.analytics === 'yes') return true;
        if (c && (c.marketing === 'no' || c.analytics === 'no')) return false;
      }
    } catch (e) {}
    try {
      if (typeof privacy.getTrackingConsent === 'function') {
        return privacy.getTrackingConsent() === 'yes';
      }
    } catch (e2) {}
    return false;
  }

  /**
   * Default policy: grant all cookies, never show banner unless setting is on.
   */
  function decideAndShow() {
    hideBanner();

    if (!bannerEnabled) {
      suppressThirdPartyBanners();
      grantAllConsent(function () {});
      return;
    }

    if (hasThirdPartyBanner()) {
      return;
    }

    var apiShow = shouldShowWithApi();
    var stored = readStoredConsent();

    if (stored && stored.choice === 'accepted') {
      if (trackingIsBlocked() || !visitorHasAccepted()) {
        grantAllConsent(function () {});
      } else {
        signalClarityConsent(true);
        flushTrackingParties();
      }
      return;
    }

    if (stored && stored.choice === 'declined') {
      if (apiShow === true) {
        showBanner();
      } else if (trackingIsBlocked()) {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
        grantAllConsent(function () {});
      } else {
        signalClarityConsent(false);
      }
      return;
    }

    if (visitorHasAccepted()) {
      writeStoredConsent('accepted');
      signalClarityConsent(true);
      flushTrackingParties();
      if (trackingIsBlocked()) grantAllConsent(function () {});
      return;
    }

    if (apiShow === true || apiShow === null) {
      showBanner();
      return;
    }

    if (apiShow === false && trackingIsBlocked()) {
      grantAllConsent(function () {});
      return;
    }

    // Non-banner region with no prior choice: still grant so pixels fire
    grantAllConsent(function () {});
  }

  function loadConsentApi(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback();
      return;
    }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback();
      return;
    }
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () {
          callback();
        }
      );
    } catch (e) {
      callback();
    }
  }

  function initBanner() {
    hideBanner();

    if (!bannerEnabled) {
      suppressThirdPartyBanners();
      var hideObs = new MutationObserver(function () {
        suppressThirdPartyBanners();
      });
      hideObs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        hideObs.disconnect();
      }, 15000);
    } else {
      bindActions();
      var obs = new MutationObserver(function () {
        if (hasThirdPartyBanner()) {
          hideBanner();
          obs.disconnect();
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
      }, 12000);
    }

    loadConsentApi(function () {
      // Auto-grant path: run ASAP; banner path still waits briefly for CMP injection
      if (!bannerEnabled) {
        decideAndShow();
        setTimeout(function () {
          suppressThirdPartyBanners();
          if (trackingIsBlocked()) grantAllConsent(function () {});
        }, 1800);
        return;
      }

      setTimeout(decideAndShow, 400);
      setTimeout(function () {
        if (hasThirdPartyBanner()) hideBanner();
        else decideAndShow();
      }, 1800);
    });
  }

  function start() {
    startConsentmoPolish();
    initBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
